import type { CartValidationErrorDetails } from '../types/cart';
import { CartValidationErrorKey } from './notificationMaps';

export const extractDiscontinuedProductNames = (errors: CartValidationErrorDetails[]): string[] => [
    ...new Set(
        errors
            .filter(e => e.errorCode === CartValidationErrorKey.DISCONTINUED_PRODUCT)
            .map(e => e.productName?.trim() || e.message?.trim())
            .filter((n): n is string => Boolean(n))
    ),
];
